import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "details-events bg-danger elemento" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-flex flex-column justify-content-center align-items-center py-8" }
const _hoisted_4 = { class: "my-8 h1 text-white text-center" }
const _hoisted_5 = { class: "bg-white rounded px-4 py-2 h4" }
const _hoisted_6 = { class: "row py-10 text-center align-items-center" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "content-menu bg-white border-2 border-bottom border-secondary sticky-top" }
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "d-flex overflow-auto h-55px justify-content-center" }
const _hoisted_12 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_17 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_20 = { class: "nav-item d-none" }
const _hoisted_21 = { class: "container py-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_avatar, {
            size: 120,
            src: _ctx.evento.logo,
            class: "bg-white p-2 shadow"
          }, null, 8, ["src"]),
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.evento.name), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.sport.name), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.botones.flagPosiciones)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "btn btn-danger mb-4",
                href: _ctx.link1,
                target: "_blank"
              }, "Posiciones", 8, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.botones.flagLlaves)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "btn btn-danger mb-4",
                href: _ctx.link2,
                target: "_blank"
              }, "Llaves", 8, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("ul", _hoisted_12, [
            (_ctx.sport.categorie == '1')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("li", _hoisted_13, [
                    _createVNode(_component_router_link, {
                      class: "nav-link text-active-primary me-6",
                      to: `/public/tournaments/${_ctx.idevent}/${_ctx.idsport}/fixture`,
                      "active-class": "active"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Fixture ")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      class: "nav-link text-active-primary me-6",
                      to: `/public/tournaments/${_ctx.idevent}/${_ctx.idsport}/meetings`,
                      "active-class": "active"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Encuentros ")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", _hoisted_15, [
                    _createVNode(_component_router_link, {
                      class: "nav-link text-active-primary me-6",
                      to: `/public/tournaments/${_ctx.idevent}/${_ctx.idsport}/winscore`,
                      "active-class": "active"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Resultados ")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  (_ctx.sport.idsport == 6 || _ctx.sport.idsport == 7 || _ctx.sport.idsport == 5 || _ctx.sport.idsport == 42)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                        _createVNode(_component_router_link, {
                          class: "nav-link text-active-primary me-6",
                          to: `/public/tournaments/${_ctx.idevent}/${_ctx.idsport}/goalscorers`,
                          "active-class": "active"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Goleadores ")
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.sport.idsport == 6 || _ctx.sport.idsport == 7 || _ctx.sport.idsport == 5 || _ctx.sport.idsport == 42)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                        _createVNode(_component_router_link, {
                          class: "nav-link text-active-primary me-6",
                          to: `/public/tournaments/${_ctx.idevent}/${_ctx.idsport}/cards`,
                          "active-class": "active"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Sanciones ")
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_18, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/public/tournaments/${_ctx.idevent}/${_ctx.idsport}/teams`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Equipos ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            (_ctx.sport.categorie == '2')
              ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                  _createVNode(_component_router_link, {
                    class: "nav-link text-active-primary me-6",
                    to: `/public/tournaments/${_ctx.idevent}/${_ctx.idsport}/ranking`,
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ranking ")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_20, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/public/tournaments/${_ctx.idevent}/${_ctx.idsport}/staff`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Staff/Árbitros ")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}